import { isUndefined } from 'angular';
import template from './accordion-item.html';

class AccordionItemController {
  constructor() {
    this._panelId = Math.random();
  }

  $onInit() {
    if (isUndefined(this.tabId)) {
      this.tabId = Math.random();
    }
  }

  get panelId() {
    return this._panelId;
  }

  get expanded() {
    return this.accordionCtrl.isExpanded(this.tabId);
  }

  toggle() {
    this.accordionCtrl.toggleId(this.tabId);
  }
}

export const AccordionItemComponent = {
  controller: AccordionItemController,
  bindings: {
    label: '@',
    tabId: '@',
  },
  require: {
    accordionCtrl: '^updAccordion',
  },
  transclude: true,
  template,
};
